import analytics from '@/store/global/analytics.store';
import api from '@/store/global/api.store';
import assets from '@/store/global/assets.store';
import modal from '@/store/global/modal.store';

export default {
	namespaced: true,
	modules: {
		analytics,
		api,
		assets,
		modal,
	},
};
